// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2OR9A","footer":"Form_footer__2wiOe"};